import React from 'react';

const LogoSmall: React.FC = () => {
  return (
    <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="42" height="42" rx="8" fill="white" />
      <path
        d="M34 25.6667V32.3333C34 33.2533 33.2533 34 32.3333 34H25.6667C24.7467 34 24 33.2533 24 32.3333V25.6667C24 24.7467 24.7467 24 25.6667 24H32.3333C33.2533 24 34 24.7467 34 25.6667Z"
        fill="#0090FF"
      />
    </svg>
  );
};

export default LogoSmall;
